import { BrowserOptions } from '@sentry/react';
import { composeMakeBreadcrumb } from './composeMakeBreadcrumb';
import { makeClickBreadcrumb } from './makeClickBreadcrumb';
import { makeGraphqlBreadcrumb } from './makeGraphqlBreadcrumb';
import { makeInputBreadcrumb } from './makeInputBreadcrumb';

const makeBreadcrumb = composeMakeBreadcrumb(
  makeClickBreadcrumb,
  makeInputBreadcrumb,
  makeGraphqlBreadcrumb,
);

export const beforeBreadcrumb: NonNullable<
  BrowserOptions['beforeBreadcrumb']
> = (breadcrumb, hint?) => {
  return makeBreadcrumb(breadcrumb, hint);
};
